module.exports = __webpack_public_path__ + "static/img/banner-empleos-home-1024x768.c1e78a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/banner-empleos-home-1024x768.jpg
// module id = sEP7
// module chunks = 47